import { configureStore } from '@reduxjs/toolkit';
import { useDispatch, useStore } from 'react-redux';
import logger from 'redux-logger';
import { createViewportSyncMiddleware } from 'app/stores/history/viewportSync';
import { createPlatformAuthorizationMiddleware } from 'app/stores/publish/middleware';
import { getReducer } from 'app/stores/reducer';
import { isDevel } from 'app/utils/varia';
export function createStore() {
    const store = configureStore({
        reducer: getReducer(),
        middleware: getDefaultMiddleware => {
            const middleware = getDefaultMiddleware({
                serializableCheck: {
                    ignoreActions: true,
                },
            }).concat([
                createViewportSyncMiddleware(),
                createPlatformAuthorizationMiddleware(),
            ]);
            if (isDevel) {
                return middleware.concat([logger]);
            }
            return middleware;
        },
        devTools: isDevel,
    });
    if (isDevel) {
        window.store = store;
    }
    return store;
}
export const useAppDispatch = useDispatch;
export const useAppStore = useStore;
